import { render, staticRenderFns } from "./PxOrigemCompraValue.vue?vue&type=template&id=79c00b4e"
import script from "./PxOrigemCompraValue.vue?vue&type=script&lang=js"
export * from "./PxOrigemCompraValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports